<template>
  <div class="wrapper box_v">
    <div class="header-wrapper">
      <div class="iconfont icon-fanhui2" @click="$router.go(-1)"></div>
      <div class="header">商品发布</div>
      <div class="box">
        <Button class="bkcc-btn" :loading="caogaoLoading" @click="submitGood('caogao')">保存草稿</Button>
        <Button class="bkcc-btn" :loading="fabuLoading" @click="submitGood('fabu')">发布</Button>
      </div>
    </div>
    <div class="box_f1 box card-wrapper">
      <!--左侧商品相关信息卡片-->
      <Card class="info-card">
        <p slot="title" style="font-size: 16px">商品信息</p>
        <!--商品图片-->
        <div class="box between mar-btm20">
          <div class="box mr20" style="margin-right: 20px">商品图片</div>
          <div class="box_f1" style="width: 435px">
            <upload-img
              :imgArr="good.imgArr"
              :imgNumber="imgNumber"
              :fixedNumber="fixedNumber"
              :imgHeight="350"
              :imgWidth="435"
              @saveImg="saveImg"
              :isActive="isActive"
            >
              <div class="uploadbox">
                <div class="iconfont icon-shangchuan1 add"></div>
                <div class="tr1">请上传图片</div>
                <div class="tr2">注意图片尺寸为5：4</div>
              </div>
            </upload-img>
          </div>
        </div>
        <!--商品标题-->
        <div class="box between mar-btm20">
          <div class="box mr20" style="margin-right: 20px">商品标题</div>
          <Input class="box_f1" v-model="good.title" style="width: 435px"/>
        </div>
        <!--商品详情 -->
        <div class="box between mar-btm20" style="position:relative;">
          <div class="box mr20" style="margin-right: 20px">商品详情</div>
          <Input class="box_f1" v-model="good.detail" type="textarea" :rows="4" style="width: 435px" :maxlength="150"/>
          <div class="text-num">{{good.detail.length}}/150</div>
        </div>
      </Card>
      <!--右侧商品兑换领取信息-->
      <div class="box_f1 box_v between right-card">
        <Card class="duihuan-card">
          <p slot="title" style="font-size: 16px">兑换信息</p>
          <div>
            <!--兑换来源-->
            <div class="box mar-btm20">
              <div class="title1">兑换来源</div>
              <CheckboxGroup v-model="good.laiyuan">
                <Checkbox v-for="item in laiyuanList" :label="item.id" class="checkbox-item">{{item.name}}</Checkbox>
              </CheckboxGroup>
            </div>
            <!--积分来源-->
            <div class="box mar-btm20">
              <div class="title1">积分来源</div>
              <div style="position:relative">
                <Select v-model="good.source" multiple style="width:420px">
                 <Option v-for="(item,index) in sourceArray" :value="item.value" :key="item.value"  @click.native="selectChange(item,index)">{{ item.source }}</Option>
                </Select>
                <!-- <div class="peoplelist box">
                  <div v-for="(item,index) in sourceArray_select" :key="index" class="box item_people" @click="deletePeople(index)">
                    <div>{{ item.source}}</div>
                    <div class="quxiao">×</div>
                  </div>
                </div> -->
              </div>
            </div>
            <!--商品积分-->
            <div class="box mar-btm20">
              <div class="title1">商品积分</div>
              <InputNumber :min="1" v-model="good.score" style="width: 420px"></InputNumber>
            </div>
            <!--商品数量-->
            <div class="box mar-btm20">
              <div class="title1">商品数量</div>
              <InputNumber :min="1" v-model="good.num" style="width: 420px"></InputNumber>
            </div>
          </div>
        </Card>
        <Card class="lingqu-card">
          <p slot="title" style="font-size: 16px">领取信息</p>
          <!--领取地点-->
          <div class="box mar-btm20">
            <div class="title2">领取地点</div>
            <div v-if="didian" class="address"  @click="showmap()">{{didian}}</div>
            <div v-else @click="showmap()" class="address address_nodata">请选择地点</div>
            <map-modal v-if="showMap"
                @confirm="getAddress"
                @cancel="showmap"
                :zuobiao="zuobiao"></map-modal>
          </div>
          <!--领取开始时间-->
          <div class="box mar-btm20">
            <div class="title2">领取开始时间</div>
            <DatePicker type="date" placeholder="请选择日期" class="data-picker" v-model="good.startDate"></DatePicker>
            <TimePicker type="time" placeholder="请选择时间" style="width: 180px" v-model="good.startTime" format="HH:mm"></TimePicker>
          </div>
          <!--结束开始时间-->
          <div class="box mar-btm20">
            <div class="title2">结束开始时间</div>
            <DatePicker type="date" placeholder="请选择日期" class="data-picker" v-model="good.endDate"></DatePicker>
            <TimePicker type="time" placeholder="请选择时间" style="width: 180px" v-model="good.endTime" format="HH:mm"></TimePicker>
          </div>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
  import uploadImg from "../../../components/uploadImg";
  import mapModal from '../../../components/mapModal';

  export default {
    name: 'newExchange',
    components: {
      uploadImg,
      mapModal
    },
    data() {
      return {
        id: '',
        isActive: false,
        imgNumber: 1,
        fixedNumber: [5, 4],
        laiyuanList: [{
          name: '先锋e家',
          id: 'xfej'
        }, {
          name: '民生通',
          id: 'mst'
        }],
        sourceArray: [
          // {
          //   source: '全部',
          //   value: 99,
          //   isSelect:false,
          // },
          {
            source: '事件',
            value: 8,
            isSelect:false,
          }, {
            source: '活动',
            value: 6,
            isSelect:false,
          }, {
            source: '其他',
            value: -1,
            isSelect:false,
          },
        ],
        //sourceArray_select:[],
        caogaoLoading: false,//草稿按鈕加載狀態
        fabuLoading: false,//发布按钮加载状态
        good: {
          imgArr: [],
          title: '',//商品标题
          detail: '',//商品详情
          laiyuan: [],//选择的来源
          source: '',//积分来源
          score: '',//商品积分
          num: '',//商品数量
          startDate: '',//开始日期
          startTime: '',//开始时间
          endDate: '',//结束日期
          endTime: '',//结束时间
        },
        zuobiao: {
          label: '',
          value: ''
        },
        didian:'',
        showMap:false
      }
    },
    methods: {
      saveImg(data) {
        this.good.imgArr.splice(0, 1, data);
        this.isActive = true;
      },
      submitGood(type) {
        var good = this.good;
          //从组件中获取地址信息

        good.address = this.zuobiao.label
        good.coordinate = this.zuobiao.value
        //检验表单
        if (type == 'fabu') {
          for (let key in good) {
            if (!good[key] || (this._.isArray(good[key]) && !good[key].length)) {
              console.log(key)
              console.log(good[key])
              console.log(good[key] == '')
              this.$Message.warning('请完善发布信息')
              return
            }
          }
        }
        if (!/^\d+$/.test(good.num)) {
          this.$Message.warning('商品数量应为整数')
          return
        }
        if (!/^\d+$/.test(good.score)) {
          this.$Message.warning('商品积分应为整数')
          return
        }
        var url = this.urlobj.submitGood
        var data = {
          id: this.id,//商品ID，不传或-1代表新增,
          coverPicUrl: good.imgArr.length ? good.imgArr[0].path : '',//封面图片URL,
          title: good.title,//标题,
          remark: good.detail,//商品详情,
          score: good.score ? parseInt(good.score) * 100 : '',//商品积分--单位是分（100相当于1积分）,
          //scoreSource: good.source == 99 ? null : good.source,//积分来源:6--活动，8--事件，-1--其他，null--全部,
          scoreSource:good.source.join(","),
          quantity: good.num,//商品数量,
          limitNumber: 1,//每人兑换商品上限次数，默认1个,
          address: good.address,//地点,
          coordinate: good.coordinate ? JSON.stringify({
            x: good.coordinate.split(' ')[0],
            y: good.coordinate.split(' ')[1],
          }) : '',//坐标JSON格式{"x":"116.4068","y":"39.904717"},
          beginTime: good.startDate && good.startTime ? `${this.$util.FormatDate(good.startDate.valueOf(), "yyyy-MM-dd")} ${good.startTime}` : null,//领取开始时间yyyy-MM-dd HH:mm:ss,
          endTime: good.endDate && good.endTime ? `${this.$util.FormatDate(good.endDate.valueOf(), "yyyy-MM-dd")} ${good.endTime}` : null,//领取结束时间yyyy-MM-dd HH:mm:ss,
          isSend: type == 'fabu' ? 1 : 0,//是否发布 0：草稿， 1：已发布,
          source: good.laiyuan.length ? good.laiyuan : [],//商品来源列表['xfej','mst']
        }
        this[`${type}Loading`] = true
        this.$post(url, data).then(res => {
          this[`${type}Loading`] = false
          this.$Message.success('提交成功')
          setTimeout(() => {
            this.$router.go(-1)
          }, 1500)
        }).catch(e => {
          this[`${type}Loading`] = false
        })
      },
      //获取详情  草稿的
      getDetail() {
        var url = this.urlobj.getGoodDetail(this.id)
        this.$get(url).then(res => {
          var info = res.rows[0]
          this.isActive = info.coverPicUrl ? true : false;
          this.didian = info.address
          this.zuobiao = {
            label: info.address,
            value: JSON.parse(info.coordinate).x + ',' + JSON.parse(info.coordinate).y
          }
          console.log(this.zuobiao)
          this.good = {
            imgArr: [{
              path: info.coverPicUrl
            }],
            title: info.title,//商品标题
            detail: info.remark,//商品详情
            laiyuan: info.source,//选择的来源
            //source: info.scoreSource || 99,//积分来源
            source: info.scoreSource?info.scoreSource.split(",").map(item=>parseInt(item)):'',//积分来源
            score: info.score / 100,//商品积分
            num: info.quantity,//商品数量
            startDate: info.beginTime.replace(/\.0/g, '').split(' ')[0],//开始日期
            startTime: info.beginTime.replace(/\.0/g, '').split(' ')[1],//开始时间
            endDate: info.endTime.replace(/\.0/g, '').split(' ')[0],//结束日期
            endTime: info.endTime.replace(/\.0/g, '').split(' ')[1],//结束时间
          }
          console.log(this.good)
        })
      },
      /*----------地图选择--------------*/
      showmap() {
        this.showMap = !this.showMap;
      },
      getAddress(val){
        this.zuobiao = val
        console.log('-------newExchange----------')
        console.log(this.zuobiao)
        this.didian = val.label
        this.coordinate = val.value
        this.showmap()
      },
      /**积分来源部分 */
      /**选积分来源下来框 */
      selectChange(item,index){
        console.log(this.good.source)
        console.log(item)
        this.sourceArray[index].isSelect = !this.sourceArray[index].isSelect
        if(item.value==99){
          //选择全部
            if(this.good.source.indexOf(99)>-1){
              this.good.source = this.sourceArray.map(item=>item.value)
              this.sourceArray.forEach(item=>item.isSelect = true)
            }else{
              this.good.source=[]
              this.sourceArray.forEach(item=>item.isSelect = false)
            }
          console.log(this.good.source)
        }else{
          //选择其他
          let _tmpList = this.sourceArray.filter(item=>item.value!=99)
          let isHasAll = this.good.source.indexOf(99) //当前选项中是否有全部
          if(_tmpList.length == this.good.source.length && (isHasAll==-1)){
            //如果除了全部，其他选项都被选择,则把全部也选中
            this.good.source.push(99)
            this.sourceArray.forEach(item=>item.isSelect = true)
          }else if(isHasAll>-1){
            //如果全部被选中，取消选择某一个选项,则取消选中全部
            this.good.source.splice(isHasAll,1)
          }

        }
      },
      /**删除积分来源 */
      deletePeople(index){
        let value = this.sourceArray[index].value;
        if( value == 99 ){
          //删除全部
          this.sourceArray.forEach(item=>item.isSelect=false)
          this.good.source=[]
        }else{
          //删除莫一项
           this.sourceArray[index].isSelect = false
           let _index = this.good.source.indexOf(value)
           this.good.source.splice(_index,1)
        }

      },

      /**积分来源部分---end */

    },
    mounted() {
      console.log(this.$store.state.apptype);
      if (this.$store.state.apptype == "ipy") {
        this.laiyuanList[1].id = "ipy";
        this.laiyuanList[1].name = "i濮阳";
      } else if (this.$store.state.apptype == "ctt") {
        this.laiyuanList[0].id = "ctxf";
        this.laiyuanList[0].name = "丛台先锋";
        this.laiyuanList[1].id = "ctt";
        this.laiyuanList[1].name = "丛台通";
      }
      if (this.$route.query.id) {
        this.id = this.$route.query.id
        this.getDetail()
      }
    }
  }
</script>

<style scoped lang="less">
  .wrapper {
    height: 100%;
  }

  .between {
    justify-content: space-between;
  }

  .mar-btm20 {
    margin-bottom: 20px;
  }

  .header-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 84px;
    line-height: 84px;
    position: relative;
    padding: 0 20px;
    .iconfont {
      color: #999;
      font-size: 24px;
    }
    .header {
      font-size: 25px;
      text-align: center;
    }
  }
  .card-wrapper {
    padding: 0 20px 30px 20px;
    .info-card {
      width: 560px;
      margin-right: 20px;
      font-size: 15px;
      color: #333;
      .uploadbox {
        width: 435px;
        height: 350px;
        border: 1px dashed #ddd;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .add {
          font-size: 52px;
          color: #d3d3d3;
          margin-bottom: -15px;
        }
        .tr1 {
          font-size: 14px;
          color: #666;
        }
        .tr2 {
          font-size: 15px;
          color: #999;
        }
      }
    }
    .duihuan-card {
      height: 48.5%;
      width: 100%;
      font-size: 15px;
      color: #333;
      .title1 {
        margin-right: 20px;
      }
    }
    .lingqu-card {
      height: 48.5%;
      width: 100%;
      font-size: 15px;
      color: #333;
      .title2 {
        width: 100px;
        text-align: right;
        margin-right: 20px;
      }
      .data-picker {
        width: 210px;
        margin-right: 30px;
      }
    }
  }

  .text-num {
    position: absolute;
    bottom: 10px;
    right: 10px;
    font-size: 14px;
    color: #999;
    line-height: 1;
  }

  /*选择地点的样式*/
.address{
    width: 420px;
    height: 32px;
    line-height: 24px;
    padding: 4px 7px;
    font-size: 12px;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    color: #515a6e;
    background-color: #fff;
    background-image: none;
    position: relative;
    cursor: text;

}
.address_nodata{
  color:#bbb
}
.address:hover{
  border: 1px solid #ff7b44;
}
.address:active{
  border: 1px solid #ff7b44;
}

/deep/ .ivu-tag {
    background-color: #fff;
    border: 1px solid #ff7b44;
  }
  /deep/ .ivu-icon-ios-close {
    color: #ff7b44;
    transform: scale(1) !important;
    opacity: 1 !important;
  }
  /deep/ .ivu-tag-text {
    color: #ff7b44;
  }

/*积分来源列表*/
.peoplelist{
  position: absolute;
  top: 1px;
  left: 6px;
  background-color: #fff;
  color:#ff7b44;
  font-size: 13px;
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  .item_people{
    border:1px solid #ff7b44;
    border-radius: 3px;
    padding:0 8px;
    height: 24px;
    line-height: 22px;
    margin: 3px 4px 3px 0;
  }
  .item_people:hover{
    cursor: pointer;
  }
  .quxiao{
    margin-left:6px;
    font-size: 13px
  }
   .ivu-btn {
    font-size: 16px;
    line-height: 1;
    margin-top: 5px;
  }
  /deep/ .ivu-btn-primary{
    background-color: #ff7b44;
    border-color:#ff7b44
  }
}
</style>
